import { DestroyRef, inject, Injectable, provideAppInitializer } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { poll } from 'ngxtension/poll';
import { exhaustMap, merge, of, Subscription } from 'rxjs';
import { UsersService } from '../../users';

import { ofType } from '@ngneat/effects';
import { Actions } from '@ngneat/effects-ng';
import {
  OrganizationsStore,
  OrgInvitationNotification,
  OrgTentativeEventNotification,
} from '../state';
import { fetchRequiredActions } from './actions';

export function provideOrgNotificationServiceInitializer() {
  return provideAppInitializer(() => {
    const service = inject(OrgNotificationService);
    service.startPolling();
  });
}

@Injectable({
  providedIn: 'root',
})
export class OrgNotificationService {
  #userService = inject(UsersService);
  #orgStore = inject(OrganizationsStore);
  #destroyRef = inject(DestroyRef);
  #actions = inject(Actions);
  subscription: Subscription | undefined;

  startPolling() {
    this.subscription = merge(
      of(null).pipe(poll(2 * 60 * 1000, 0)),
      this.#actions.pipe(ofType(fetchRequiredActions)),
    )
      .pipe(exhaustMap(() => this.#userService.fetchRequiredActions()))
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((response) => {
        this.#orgStore.setNotifications([
          ...(response.has_invitations
            ? [{ type: 'invitation' as const } satisfies OrgInvitationNotification]
            : []),
          ...response.tentative_event_organizations.map(
            (orgId) =>
              ({
                type: 'tentative_event' as const,
                org_id: orgId,
              }) satisfies OrgTentativeEventNotification,
          ),
        ]);
      });
  }

  stopPolling() {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
  }
}
